export default "__VITE_ASSET___F7DmfV5__"